import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';


export class EtiquetasCoreView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productos: [],
            tiposFruta: [],
            colillas: [],
            cartones: []
        };
        if (props.data) {
            this.state.model = props.data
        }
        else {
            this.state.model = { nombre: "", producto_Id: 0, tipoFruta_Id: 0, colilla_Id: 0, carton_Id: 0, naturaleza: "Original", observaciones: "", color:"", habilitado: true, producto: "" };
        }
        this.state.modelValidation = {
            producto_Id: this.state.model.producto_Id != 0,
            tipoFruta_Id: this.state.model.tipoFruta_Id != 0,
            colilla_Id: this.state.model.colilla_Id != 0,
            carton_Id: this.state.model.carton_Id != 0,
            nombre: this.state.model.nombre != "",
            producto: this.state.model.producto != ""
        }
        this.load_colillas = this.load_colillas.bind(this);
        this.load_cartones = this.load_cartones.bind(this);
        this.load_productos = this.load_productos.bind(this);
        this.load_tiposFruta = this.load_tiposFruta.bind(this);
        this.populateData = this.populateData.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000)
    }

    async handleChange(event) {
        var value = event.target.value;
        console.log("target", event.target);
        console.log("event", event);
        if (event.target.name == "habilitado") {
            value = value == "true";
        }
        var tempModel = this.state.model;
        tempModel[event.target.name] = value;
        if (event.target.name == "producto_Id") {
            var producto = event.target.selectedOptions[0].text;
            tempModel["producto"] = producto;
            if (producto != "Piña") {
                tempModel["color"] = "";
            }
        }
        this.setState({
            model: tempModel
        }, async () => {
            if (event.target.name == "producto_Id") {
                this.setState({
                    tiposFruta: await this.load_tiposFruta()
                });
            }
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });

    }
    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/etiquetasCore/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }

    render() {
        return (
            <div >
                <Row>
                    <Form>
                        <Row>
                            <FormGroup className="col col-md-4">
                                <Label for="producto_Id">
                                    <FormattedMessage id='Producto' />
                                </Label>
                                <Input
                                    id="producto_Id"
                                    name="producto_Id"
                                    type="select"
                                    onChange={this.handleChange}
                                    valid={this.getValidationValue(this.state.modelValidation.producto_Id)}
                                    invalid={!this.getValidationValue(this.state.modelValidation.producto_Id)}
                                >
                                    <option value="0"></option>
                                    {this.state.productos.map(producto => producto.producto_Id == this.state.model.producto_Id ? (
                                        <option value={producto.producto_Id} selected>
                                            {producto.nombre}
                                        </option>
                                    ) : (<option value={producto.producto_Id}>{producto.nombre}</option>))}
                                </Input>
                                <FormFeedback>
                                    {this.state.model.producto_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                </FormFeedback>
                            </FormGroup>
                            <FormGroup className="col col-md-4">
                                <Label for="tipoFruta_Id">
                                    <FormattedMessage id='TiposFruta' />
                                </Label>
                                <Input
                                    id="tipoFruta_Id"
                                    name="tipoFruta_Id"
                                    type="select"
                                    onChange={this.handleChange}
                                    valid={this.getValidationValue(this.state.modelValidation.tipoFruta_Id)}
                                    invalid={!this.getValidationValue(this.state.modelValidation.tipoFruta_Id)}
                                >
                                    <option value="0"></option>
                                    {this.state.tiposFruta.map(tipoFruta => tipoFruta.tipoFruta_Id == this.state.model.tipoFruta_Id ? (
                                        <option value={tipoFruta.tipoFruta_Id} selected>
                                            {tipoFruta.nombre}
                                        </option>
                                    ) : (<option value={tipoFruta.tipoFruta_Id}>{tipoFruta.nombre}</option>))}
                                </Input>
                                <FormFeedback>
                                    {this.state.model.tipoFruta_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                </FormFeedback>
                            </FormGroup>
                            <FormGroup className="col col-md-4">
                                <Label for="colilla_Id">
                                    <FormattedMessage id='Colilla' />
                                </Label>
                                <Input
                                    id="colilla_Id"
                                    name="colilla_Id"
                                    type="select"
                                    onChange={this.handleChange}
                                    valid={this.getValidationValue(this.state.modelValidation.colilla_Id)}
                                    invalid={!this.getValidationValue(this.state.modelValidation.colilla_Id)}
                                >
                                    <option value="0"></option>
                                    {this.state.colillas.map(colilla => colilla.colilla_Id == this.state.model.colilla_Id ? (
                                        <option value={colilla.colilla_Id} selected>
                                            {colilla.nombre}
                                        </option>
                                    ) : (<option value={colilla.colilla_Id}>{colilla.nombre}</option>))}
                                </Input>
                                <FormFeedback>
                                    {this.state.model.colilla_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                </FormFeedback>
                            </FormGroup>
                        </Row>
                        <Row>
                            <FormGroup className="col col-md-4">
                                <Label for="carton_Id">
                                    <FormattedMessage id='Carton' />
                                </Label>
                                <Input
                                    id="carton_Id"
                                    name="carton_Id"
                                    type="select"
                                    onChange={this.handleChange}
                                    valid={this.getValidationValue(this.state.modelValidation.carton_Id)}
                                    invalid={!this.getValidationValue(this.state.modelValidation.carton_Id)}
                                >
                                    <option value="0"></option>
                                    {this.state.cartones.map(carton => carton.carton_Id == this.state.model.carton_Id ? (
                                        <option value={carton.carton_Id} selected>
                                            {carton.nombre}
                                        </option>
                                    ) : (<option value={carton.carton_Id}>{carton.nombre}</option>))}
                                </Input>
                                <FormFeedback>
                                    {this.state.model.carton_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                </FormFeedback>
                            </FormGroup>
                            <FormGroup className="col">
                                <Label for="observaciones">
                                    <FormattedMessage id='Distintivo adicional' />
                                </Label>
                                <FormattedMessage id='Distintivo adicional'>
                                    {(placeholder) =>
                                        <Input
                                            id="observaciones"
                                            name="observaciones"
                                            //placeholder={placeholder}
                                            type="text"
                                            onChange={this.handleChange}
                                            value={this.state.model.observaciones}
                                        />
                                    }
                                </FormattedMessage>
                            </FormGroup>
                        </Row>
                        <Row>
                            <FormGroup className="col col-md-6">
                                <Label for="nombre">
                                    <FormattedMessage id='Etiqueta CORE' />
                                </Label>
                                <FormattedMessage id='Nombre'>
                                    {(placeholder) =>
                                        <Input
                                            id="nombre"
                                            name="nombre"
                                            //placeholder={placeholder}
                                            type="text"
                                            onChange={this.handleChange}
                                            value={this.state.model.nombre}
                                            valid={this.getValidationValue(this.state.modelValidation.nombre)}
                                            invalid={!this.getValidationValue(this.state.modelValidation.nombre)}
                                        />
                                    }
                                </FormattedMessage>
                                <FormFeedback>
                                    {this.state.model.nombre == '' ? <FormattedMessage id='Este campo es requerido' /> : <FormattedMessage id='Este nombre ya esta siendo usado' />}
                                </FormFeedback>
                            </FormGroup>
                            <FormGroup className="col">
                                <Label for="color">
                                    <FormattedMessage id='Color' />
                                </Label>
                                <Input
                                    id="color"
                                    name="color"
                                    type="select"
                                    onChange={this.handleChange}
                                    value={this.state.model.color}
                                    valid={this.getValidationValue(this.state.modelValidation.color)}
                                    invalid={!this.getValidationValue(this.state.modelValidation.color)}
                                    disabled={this.state.model.producto != "Piña"}
                                >
                                    <option value='' ></option>
                                    <option value='Verde' ><FormattedMessage id='Verde' /></option>
                                    <option value='Intermedio' ><FormattedMessage id='Intermedio' /></option>
                                    <option value='Oro' ><FormattedMessage id='Oro' /></option>
                                </Input>
                            </FormGroup>

                        </Row>
                        <Row>
                            <FormGroup className="col col-md-3">
                                <Label for="naturaleza">
                                    <FormattedMessage id='Naturaleza' />
                                </Label>
                                <Input
                                    id="naturaleza"
                                    name="naturaleza"
                                    type="select"
                                    onChange={this.handleChange}
                                    value={this.state.model.naturaleza}
                                >
                                    <option value='Original' ><FormattedMessage id='Original' /></option>
                                    <option value='Excepcional' ><FormattedMessage id='Excepcional' /></option>
                                </Input>
                            </FormGroup>
                            <FormGroup className="col col-md-3">
                                <Label for="habilitado">
                                    <FormattedMessage id='Habilitado' />
                                </Label>
                                <Input
                                    id="habilitado"
                                    name="habilitado"
                                    type="select"
                                    onChange={this.handleChange}
                                    value={this.state.model.habilitado}
                                >
                                    <option value={true} ><FormattedMessage id='Habilitado' /></option>
                                    <option value={false} ><FormattedMessage id='Deshabilitado' /></option>
                                </Input>
                            </FormGroup>
                        </Row>
                    </Form>
                </Row>
            </div>
        );
    }
    componentDidMount() {
        this.populateData();
    }
    async populateData() {
        this.setState({ loading: true, productos: await this.load_productos(), colillas: await this.load_colillas(), cartones: await this.load_cartones() }, async () => {
            this.setState({ tiposFruta: await this.load_tiposFruta() })
        });

    }
    async load_colillas() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/colillas/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_cartones() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/cartones/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_productos() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/productos/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_tiposFruta() {
        if (this.state.model.producto_Id != 0) {
            const token = await authService.getAccessToken();
            const response = await fetch('api/tiposFruta?producto_Id=' + this.state.model.producto_Id, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            });
            return await response.json();
        }
        else {
            return [];
        }
    }
}